module.exports = __webpack_public_path__ + "img/event1.5d9cb586.png";